import React, { Component } from 'react';

import classes from './ProgressBar.css';

class ProgressBar extends Component {

  state = {

  }

  render() {

    let points = [];
    for (let i = 0; i < this.props.numPoints; i++) {
      if (this.props.progress >= this.props.numPoints) {
        points.push((
          <div className={[classes.Point, classes.PointFinished].join(' ')}></div>
        ));
      } else if (this.props.progress > i) {
        points.push((
          <div className={[classes.Point, classes.PointProgressed].join(' ')}></div>
        ));
      } else {
        points.push((
          <div className={classes.Point}></div>
        ));
      }

      if (i < this.props.numPoints - 1) {
        if (this.props.progress >= this.props.numPoints) {
          points.push(<div className={[classes.Connection, classes.ConnectionFinished].join(' ')}></div>)
        } else if (this.props.progress - 1 > i) {
          points.push(<div className={[classes.Connection, classes.ConnectionProgressed].join(' ')}></div>)
        } else {
          points.push(<div className={classes.Connection}></div>)
        }

      }
    }

    return (
      <div className={classes.ProgressBarHolder}>
        { points }
        <p className={classes.Message}>{this.props.message}</p>
      </div>
    );
  }

}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/UI/NewRequestSequential/ProgressBar/ProgressBar.js